import React, {useContext} from 'react';
import {SellFactorSCLContext} from "./SellFactorContext";
import NewTabulator from "../NewTabulator/NewTabulator";
import SclJozSelectOptionAdder from "./components/SclJozSelectOptionAdder";
import SclJozTable from "./components/SclJozTable";

function SellFactorSclJoz(props) {
  const helper = useContext(SellFactorSCLContext);
  const setData = helper.setData
  const data = helper.data


  return (<div>
    <SclJozSelectOptionAdder/>
    <SclJozTable/>

  </div>);
}

export default SellFactorSclJoz;